<!-- 评价导师 -->
<template>
  <div>
    <zlr-modal v-model="isShow">
      <div class="essay-modify-evaluate">
        <h1>Feedback</h1>
        <h3>{{data.editType === 'SMEDIT'? 'SM': 'EM'}}导师 - {{data.mentorName}}</h3>
        <div class="cv-rl-evaluate-html"
             v-html="data.mentorEdit? data.mentorEdit.steer: ''">
          {{data.mentorEdit? data.mentorEdit.steer: ''}}
        </div>
        <h2>评价导师</h2>
        <ul class="mentor-detail">
          <li>{{detail.projectUniver}}</li>
          <li>{{detail.projectName}}</li>
          <li>{{data.editType === 'SMEDIT'? 'SM': 'EM'}}导师 - {{data.mentorName}}</li>
        </ul>
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate"
              label-position="top">
          <FormItem prop="graded"
                    v-if="simple">
            <div class="essay-modify-evaluate-rate">
              <Rate v-model="formValidate.graded"></Rate>
            </div>
          </FormItem>
          <template v-else>
            <FormItem label="导师文书修改程度是否达到预期？"
                      prop="materialModifyGraded">
              <Evaluation v-model="formValidate.materialModifyGraded"
                          :label="studentEvaluation5"
                          @on-change="changeModifyGraded"></Evaluation>
            </FormItem>
            <FormItem label="你觉得这个Module对你有帮助吗？"
                      prop="moduleHelpfulGraded"
                      v-if="moduleFinish">
              <Evaluation v-model="formValidate.moduleHelpfulGraded"
                          :label="studentEvaluation4"></Evaluation>
            </FormItem>
          </template>
          <FormItem :label="isRequired ? '请填写说明未达到预期的原因': ''"
                    prop="content"
                    :show-message="isRequired">
            <div class="essay-modify-evaluate-editor">
              <editor ref="analysisEditor"
                      :cache=false
                      v-model="formValidate.content" />
            </div>
          </FormItem>
          <div class="essay-modify-evaluate-btn">
            <div style="display:inline-block;" v-if="isallowedit">
              <Button class="btn btn-sub"
                      :loading="isSub"
                      @click="handleEvaluate">评价导师</Button>
            </div>
            <Button class="btn btn-close"
                    @click="closeHandle">关闭</Button>
          </div>
        </Form>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
import isAllowEdit from '@/view/mixins/is-edit'
// api
import { subEvaluateMaterial } from '@/api/evaluate'
import { getViewDetail } from '@/api/bill'
// components
import ZlrModal from '_c/modal/modal'
import Editor from '_c/editor/editor'
import Evaluation from '_c/mentor/evaluation'
import { studentEvaluation4, studentEvaluation5 } from '@/constant'
export default {
  name: 'project-evaluate-mentor',
  mixins: [isAllowEdit],
  components: {
    ZlrModal,
    Editor,
    Evaluation
  },
  data () {
    return {
      studentEvaluation4,
      studentEvaluation5,
      isShow: false,
      isSub: false,
      formValidate: {
        moduleHelpfulGraded: undefined,
        materialModifyGraded: undefined,
        content: '',
        graded: undefined
      },
      ruleValidate: {
        graded: [
          { required: true, message: '请选择星级' }
        ],
        materialModifyGraded: [
          { required: true, message: '请选择星级' }
        ],
        moduleHelpfulGraded: [
          { required: true, message: '请选择星级' }
        ],
        content: ''
      },
      simple: false,
      moduleFinish: false,
      data: {
        mentorEdit: {}
      },
      detail: {}
    }
  },
  computed: {
    isRequired () {
      return this.formValidate.materialModifyGraded > 0 && this.formValidate.materialModifyGraded < 3
    }
  },
  mounted () {

  },
  methods: {
    showHandle (simple, moduleFinish, data, params) {
      this.simple = simple
      this.moduleFinish = moduleFinish
      this.data = data
      this.isShow = true
      this.getViewDetail(params)
    },
    // 获取详情
    getViewDetail (params) {
      if (!params) {
        return false
      }
      getViewDetail(params).then(res => {
        this.detail = res.data.model
      })
    },
    // 关闭
    closeHandle () {
      this.$emit('on-close')
      this.isShow = false
    },
    // 提交评论
    handleEvaluate () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          data.materialId = this.data.id
          this.isSub = true
          subEvaluateMaterial(data).then(res => {
            this.$zlr_message('评论成功', 'success')
            this.isShow = false
            this.$emit('on-success')
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    },
    resetData () {
      this.formValidate = {
        moduleHelpfulGraded: undefined,
        materialModifyGraded: undefined,
        content: '',
        graded: undefined
      }
      this.$set(this.ruleValidate, 'content', '')
      this.$refs['analysisEditor'].resetHtml()
    },
    changeModifyGraded (data) {
      if (data < 3) {
        return this.$set(this.ruleValidate, 'content', [
          { required: true, message: '请填写说明未达到预期的原因' }
        ])
      }
      this.$set(this.ruleValidate, 'content', '')
    }
  },
  watch: {
    isShow (newValue) {
      if (!newValue) {
        this.resetData()
      }
    }
  }
}
</script>
<style lang='less' scoped>
.cv-rl-evaluate-html {
  margin-bottom: 40px;
}
</style>
